import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { Box, xcss } from '@atlaskit/primitives';

type Props = {
	onClose: () => void;
	label: string;
};

export const CrossButton = ({ onClose, label }: Props) => (
	<Box xcss={closeButtonStyles}>
		<IconButton icon={CrossIcon} label={label} appearance="subtle" onClick={onClose} />
	</Box>
);

const closeButtonStyles = xcss({
	position: 'absolute',
	top: '24px',
	right: '24px',
});
